<template>
  <div class="age-group-report-wrap">
    <analytics-topbar
      title="Age group wise engagement analysis"
      :isFilterApplied="isFilterApplied"
      @toggleReportFilter="toggleReportFilters"
      @resetDashFilters="resetDashFilters"
    ></analytics-topbar>
    <v-row class="age-group-report-heading">
      <v-col cols="12">
        <div class="age-group-report-title">
          Age group wise engagement analysis
        </div>
        <div class="age-group-report-sub">
          This report represents the engagement analysis of different age groups.
        </div>
      </v-col>
    </v-row>
    <v-row class="age-group-report-heading">
      <v-col cols="12" class="text-center">
        <h2>
          Coming soon...
        </h2>
      </v-col>
    </v-row>
    <!-- <div class="reportFilterDrawer">
      <reportFilters
        ref="ReportFilters"
        reportType="group_metrics"
        @getReportWithFilter="getReportWithFilter"
        @sortOptions="sortOptions"
      ></reportFilters>
    </div> -->
    <!-- <div class="report-container">
      <div class="report-wrap">
        <div class="bar-wrap">
          <div class="report-bar-graph intro-x">
            <ageOvertimeStats
              :stats-data="overallEngagements"
            ></ageOvertimeStats>
            <ageOvertimeBar
              :bar-data="overtimeBarData"
              :sort-by-key="sortByKey"
            ></ageOvertimeBar>
          </div>
          <div class="overtime-table">
            <v-row class="age-group-report-heading">
              <v-col cols="12">
                <div class="age-group-report-title">
                  Age group wise engagement score across demographics
                </div>
                <div class="age-group-report-sub">
                  Measure the group wise engagement score across demographics.
                </div>
              </v-col>
            </v-row>
            <ageOvertimeTable
              :reportDates="reportDates"
              :sort-by-data="sortByData"
              :tableData="overtimeTableData"
              @onClickSortByOvertime="onClickSortByOvertime"
            ></ageOvertimeTable>
          </div>
          <div class="driver-reports">
            <v-row class="age-group-report-heading">
              <v-col cols="12">
                <div class="age-group-report-title">
                  Age group wise engagement driver's performance
                </div>
                <div class="age-group-report-sub">
                  This report represents the driver's performance age group wise. This is useful to identify which drivers/sub drivers are working well and what needs to be improved.
                </div>
              </v-col>
            </v-row>
            <div class="report-bar-graph intro-x" style="height:550px;">
              <ageDriverStats
              :stats-data="overallParticipation"
            ></ageDriverStats>
              <ageDriverBar
              :bar-data="driverBarData"
              ></ageDriverBar>
            </div>
            <div class="driver-table">
              <v-row class="age-group-report-heading">
                <v-col cols="12">
                  <div class="age-group-report-title">
                    Driver's performance across demographics
                  </div>
                  <div class="age-group-report-sub">
                    Compare age group wise performance of the drivers across different demographics.
                  </div>
                </v-col>
              </v-row>
              <ageDriverTable
                :reportDrivers="reportDrivers"
                :sort-by-data="sortByData"
                :tableData="driverTableData"
                @onClickSortByDrivers="onClickSortByDrivers"
              ></ageDriverTable>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import AnalyticsTopbar from './analytics-topbar';
// import ReportFilters from './analytics-filters';
// import AgeOvertimeStats from './age-group-comp/age-overtime-stats';
// import AgeOvertimeBar from './age-group-comp/age-overtime-bar';
// import AgeOvertimeTable from './age-group-comp/age-overtime-table';
// import AgeDriverStats from './age-group-comp/age-driver-stats';
// import AgeDriverBar from './age-group-comp/age-driver-bar';
// import AgeDriverTable from './age-group-comp/age-driver-table';

export default {
  name: 'ageGroupEngagement',

  components: {
    // AgeOvertimeStats,
    // AgeOvertimeBar,
    // AgeOvertimeTable,
    // AgeDriverStats,
    // AgeDriverBar,
    // AgeDriverTable,
    // ReportFilters,
    AnalyticsTopbar
  },

  data () {
    return {
      activeSort: 'location',
      sortByData: {},
      isFilterApplied: false,
      sortByKey: '',
      overtimeBarData: {},
      overallEngagements: {},
      reportDates: [
        '<20',
        '20-25',
        '25-30',
        '30-40',
        '40-50',
        '>50'
      ],
      overtimeTableData: {
        Ahmedabad: {
          '<20': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '20-25': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '25-30': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '30-40': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '40-50': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '>50': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 }
        },
        Bangalore: {
          '<20': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '20-25': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '25-30': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '30-40': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '40-50': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '>50': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 }
        },
        Chennai: {
          '<20': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '20-25': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '25-30': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '30-40': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '40-50': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '>50': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 }
        },
        Delhi: {
          '<20': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '20-25': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '25-30': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '30-40': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '40-50': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '>50': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 }
        },
        Gurgaon: {
          '<20': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '20-25': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '25-30': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '30-40': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '40-50': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '>50': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 }
        },
        Mumbai: {
          '<20': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '20-25': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '25-30': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '30-40': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '40-50': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '>50': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 }
        },
        Pune: {
          '<20': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '20-25': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '25-30': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '30-40': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '40-50': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 },
          '>50': { total: 4.28, participation: 4, engagment: 5, disengaged: 2.3 }
        }
      },
      overallParticipation: {},
      driverTableData: {
        Ahmedabad: {
          Culture: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          Leadership: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          CareerOpportunities: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          WorklifeIntegration: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          PerformanceManagement: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          RewardsAndRecognition: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          Mood: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          }
        },
        Bangalore: {
          Culture: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          Leadership: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          CareerOpportunities: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          WorklifeIntegration: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          PerformanceManagement: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          RewardsAndRecognition: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          Mood: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          }
        },
        Chennai: {
          Culture: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          Leadership: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          CareerOpportunities: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          WorklifeIntegration: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          PerformanceManagement: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          RewardsAndRecognition: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          Mood: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          }
        },
        Delhi: {
          Culture: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          Leadership: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          CareerOpportunities: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          WorklifeIntegration: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          PerformanceManagement: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          RewardsAndRecognition: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          Mood: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          }
        },
        Gurgaon: {
          Culture: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          Leadership: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          CareerOpportunities: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          WorklifeIntegration: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          PerformanceManagement: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          RewardsAndRecognition: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          Mood: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          }
        },
        Mumbai: {
          Culture: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          Leadership: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          CareerOpportunities: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          WorklifeIntegration: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          PerformanceManagement: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          RewardsAndRecognition: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          Mood: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          }
        },
        Pune: {
          Culture: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          Leadership: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          CareerOpportunities: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          WorklifeIntegration: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          PerformanceManagement: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          RewardsAndRecognition: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          },
          Mood: {
            '<20': 4.28,
            '20-25': 4.28,
            '25-30': 4.28,
            '30-40': 4.28,
            '40-50': 4.28,
            '>50': 4.28
          }
        }
      },
      reportDrivers: [
        'Culture',
        'Leadership',
        'CareerOpportunities',
        'WorklifeIntegration',
        'PerformanceManagement',
        'RewardsAndRecognition',
        'Mood'
      ],
      driverBarData: {}
    };
  },

  methods: {
    sortOptions (val) {
      this.sortByData = val;
    },
    toggleReportFilters () {
      this.$refs.ReportFilters.showFilterDrawer = true;
    },
    resetDashFilters () {
      this.filterApplied = false;
      this.$refs.ReportFilters.resetFilters();
    },
    dashFiltersApplied (val) {
      this.isFilterApplied = val;
    },
    getReportWithFilter (val) {
      this.isFilterApplied = val;
      this.getLifecycleReport();
    },
    onClickSortByOvertime () {},
    onClickSortByDrivers () {}
  }
};
</script>

<style lang="scss" scoped>
.age-group-report-wrap {
  .age-group-report-heading {
    margin: 0;
    .age-group-report-title {
      color: var(--color-text);
      font-size: var(--stats-size-1);
    }
    .age-group-report-sub {
      color: var(--color-text);
      font-size: var(--content-size);
      padding: 8px 0;
    }
  }
  .report-container {
    background-color: var(--bg-panel);
    margin: 0 12px;
    .report-wrap {
      .bar-wrap {
        margin-top: 20px;
        .report-title {
          padding-bottom: 14px;
          color: var(--color-text);
          font-size: var(--heading-size);
          font-weight: var(--heading-weight);
        }
        .report-bar-graph {
          display: grid;
          grid-template-columns: 2fr 5fr;
          height: 450px;
          background: var(--bg);
          border-radius: 0.5rem;
        }
        // .overtime-table {
        //   margin: 20px 0;
        //   display: grid;
        //   grid-template-columns: 1fr;
        //   overflow: hidden;
        // }
        .driver-reports {
          .report-title {
            padding: 16px 0 6px 0;
            color: var(--color-text);
            font-size: var(--heading-size);
            font-weight: var(--heading-weight);
          }
          .driver-bar-graph {
            margin: 20px 0;
            display: grid;
            grid-template-columns: 5fr 4fr;
            // height: 600px;
            background: var(--bg);
            border-radius: 0.5rem;
          }
          // .driver-table {
          // margin: 20px 0;
          // display: grid;
          // grid-template-columns: 1fr;
          // border-radius: 0.5rem;
          // overflow: hidden;
          // }
        }
      }
      .report-trend-graph {
        margin-top: 20px;
        padding: 30px 30px;
        height: 600px;
        background: var(--bg);
        border-radius: 0.5rem;
        .trends-title {
          display: grid;
          place-items: center;
          padding-bottom: 16px;
          margin-top: -16px;
          color: var(--color-text);
          font-size: var(--heading-size);
          font-weight: var(--heading-weight);
        }
      }
    }
    .no-report-data {
      display: grid;
      grid-template-columns: 1fr;
      background-color: var(--bg);
      align-items: center;
      justify-items: center;
      margin: 50px;
      border-radius: 1rem;
      height: 300px;
      .sad-amara {
        text-align: center;
        img {
          width: 25%;
          border-radius: 100%;
        }
      }
      .am-text {
        font-size: var(--heading-size);
        color: var(--color-text);
      }
    }
    .intro-x {
      opacity: 0;
      position: relative;
      transform: translateX(80px);
      animation: 0.6s intro-x-animation ease-in-out 0.33333s;
      animation-fill-mode: forwards;
      animation-delay: 0.3s;
    }
    @keyframes intro-x-animation {
      100% {
        opacity: 1;
        transform: translateX(0px);
      }
    }
  }
}
</style>
